module.exports = __webpack_public_path__ + "static/FabrigaLight-0a0285c7ca489480ed24c4a351c822c4.woff2";